import { useImageToPromptMutation } from '../../../services/agrocraftArtisan';
import { useRef } from 'react';
import addPhotoAlternateLogo from '../../../assets/icons/add_photo_alternate.svg';
import './index.scss';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../../utils/analytics';
import {
  getLanguage,
  getLanguageLabel,
} from '../../../components/languageSelect/helpers/functions';

import { useAppDispatch } from '../../../storeHook';
import { showAlert } from '../../../reduxActions/alert';

type TProps = {
  setPrompt: React.Dispatch<React.SetStateAction<string>>;
  setIsLoadingImageToPrompt: React.Dispatch<
    React.SetStateAction<boolean>
  >;
};

export const ImageToPrompt = ({
  setPrompt,
  setIsLoadingImageToPrompt,
}: TProps) => {
  const dispatch = useAppDispatch();
  const hiddenFileInput = useRef<HTMLInputElement | null>(
    null
  );
  const [imageToPrompt] = useImageToPromptMutation();

  const handleImageToPrompt = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (
      event.currentTarget.files &&
      event.currentTarget.files.length > 0
    ) {
      const fileUploaded = event.currentTarget.files[0];
      const data = new FormData();
      data.append('image', fileUploaded);
      const langCode = getLanguage();
      const langName = getLanguageLabel(langCode) || langCode;
      data.append('lang', langName);
      appLogEvent(CUSTOM_EVENTS.IMAGE_TO_PROMPT, {
        language: langName,
      });
      setIsLoadingImageToPrompt(true);
      imageToPrompt(data)
        .unwrap()
        .then((res) => {
          const prompt = res?.prompt;
          prompt && setPrompt(prompt);
        })
        .catch((err) => {
          console.error('Error in imageToPrompt:', err);
          dispatch(
            showAlert({
              content: 'Failed to generate prompt from image. Please try again.',
              severity: 'error',
            })
          );
        })
        .finally(() => {
          setIsLoadingImageToPrompt(false);
        });
    }
  };

  const handleUploadBtnClick = () => {
    hiddenFileInput?.current?.click();
  };

  // utils/imageValidator.js or locally in your component
  const validateImageFile = (file: File) => {
    const validTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
    ];

    if (!validTypes.includes(file.type)) {
      dispatch(
        showAlert({
          content:
            'Only JPG and PNG image files are allowed.',
          severity: 'error',
        })
      );
      return false;
    }

    return true;
  };

  return (
    <div className="image-to-prompt-container">
      <div
        onClick={handleUploadBtnClick}
        className="image-to-prompt_btn">
        <img src={addPhotoAlternateLogo} />
        <span>Image to Prompt</span>
      </div>
      <input
        type="file"
        style={{ display: 'none' }}
        ref={hiddenFileInput}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (!file) return;

          if (validateImageFile(file)) {
            handleImageToPrompt(e);
          }

          e.target.value = '';
        }}
        accept=".jpg,.jpeg,.png"
      />
    </div>
  );
};
